import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/default_project_thumbnail.jpg'


const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "bg-white shadow sm:rounded-lg" }
const _hoisted_3 = { class: "rounded-t-md border-2 border-gray-200 px-4 pb-4 pt-4" }
const _hoisted_4 = {
  id: "applicant-information-title",
  class: "float-left text-xl font-bold text-gray-700"
}
const _hoisted_5 = { class: "float-right inline-flex items-center rounded-lg border border-transparent bg-white-100 px-2 py-1 text-sm font-bold text-yellow-700 hover:bg-yellow-300 hover:text-yellow-900" }
const _hoisted_6 = { class: "group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 mt-12" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  alt: "default stream thumbnail",
  class: "pointer-events-none object-cover"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString($props.stream.name), 1),
        _createVNode(_component_router_link, {
          to: {
            name: 'ProjectTimelapse',
            params: {
              customer_name: $props.stream.customer_name,
              site_id: $props.stream.site_id,
              camera_id: $props.stream.camera_id,
            },
          }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.project.stream_card.detail_view")) + " ", 1),
              _createVNode(_component_ArrowRightIcon, {
                class: "ml-2 h-4 w-4",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: $props.stream.thumbnail_url,
            alt: "",
            class: "pointer-events-none object-cover",
            onError: _cache[0] || (_cache[0] = ($event: any) => ($data.missingThumbnail = true))
          }, null, 40, _hoisted_7),
          ($data.missingThumbnail)
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}